import React from 'react';
import { Input, Textarea } from '@heroui/react';
import './index.css';
interface CustomInputProps {
  // Основные пропсы
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;

  // UI пропсы
  label?: string;
  placeholder?: string;
  variant?: 'bordered' | 'focused' | 'underlined' | 'flat' | 'faded';
  size?: 'sm' | 'md' | 'lg';
  labelPlacement?: 'inside' | 'outside' | 'outside-left';

  // Валидация
  isInvalid?: boolean;
  errorMessage?: string;
  required?: boolean;

  // Специфичные пропсы
  type?: 'text' | 'email' | 'password' | 'url' | 'tel';
  minRows?: number;
  maxRows?: number;

  // Стилизация
  className?: string;
  classNames?: {
    input?: string;
    label?: string;
    inputWrapper?: string;
  };

  // Дополнительные пропсы
  disabled?: boolean;
  readOnly?: boolean;
  autoComplete?: string;
}

const CustomInput: React.FC<CustomInputProps> = ({
  name,
  value,
  onChange,
  onBlur,
  label,
  placeholder,
  variant = 'bordered',
  size = 'sm',
  labelPlacement = 'outside',
  isInvalid = false,
  errorMessage,
  required = false,
  type = 'text',
  minRows,
  maxRows,
  className = '',
  classNames = {},
  disabled = false,
  readOnly = false,
  autoComplete,
}) => {
  // Если указаны minRows или maxRows, используем Textarea
  if (minRows || maxRows) {
    return (
      <Textarea
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        label={label}
        placeholder={placeholder}
        variant={variant}
        required={required}
        labelPlacement={labelPlacement}
        isInvalid={isInvalid}
        errorMessage={errorMessage}
        minRows={minRows}
        maxRows={maxRows}
        className={`${className}`}
        classNames={{
          input: 'text-sm',
          label: 'pb-2 text-sm',
          inputWrapper: 'rounded-lg min-h-[4.375rem]',
          ...classNames,
        }}
        disabled={disabled}
        readOnly={readOnly}
      />
    );
  }

  // Иначе используем обычный Input
  return (
    <Input
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      label={label}
      placeholder={placeholder}
      variant={variant}
      labelPlacement={labelPlacement}
      required={false}
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      size={size}
      type={type}
      className={`${className} `}
      classNames={{
        input: 'text-sm text-auth-ink',
        label: 'pb-1 text-sm',
        inputWrapper: 'rounded-lg !h-10',
        ...classNames,
      }}
      disabled={disabled}
      readOnly={readOnly}
      autoComplete={autoComplete}
    />
  );
};

export default CustomInput;
